<template>
  <article>
    <div
      v-if="(eventTransactionsStatus === 'loading')
        || (eventStatus === 'loading') || (eventsStatus === 'loading')
        || (updateTransactionsStatus === 'loading')"
      class="loader-container">
      <app-loader />
    </div>
    <add-purchase-form
      :spell-transaction-type="spellTransactionType"
      :operation-type="operationType"
      v-else-if="(operationType === 'purchase')
       || operationType === 'deposit'"
    />
<!--    <add-they-bought-me-operation-form-->
<!--      :spell-transaction-type="spellTransactionType"-->
<!--      :operation-type="operationType"-->
<!--      v-else-if="transaction === 'they purchased me'"/>-->
    <add-transfer-form
      :spell-transaction-type="spellTransactionType"
      :operation-type="operationType"
      v-else-if="operationType === 'transfer'"/>
    <add-comment-form
      :spell-transaction-type="spellTransactionType"
      :operation-type="operationType"
      v-else-if="operationType === 'comment'"/>
    <add-payback-form
      :spell-transaction-type="spellTransactionType"
      :operation-type="operationType"
      v-else-if="operationType === 'payback'"
    />
  </article>
</template>

<script>
import { mapState } from 'vuex';
import { i18n } from '@/plugins/vuei18n';
import AddPurchaseForm from '../AddPurchaseForm/AddPurchaseForm';
import AddTransferForm from '../AddTransferForm/AddTransferForm';
import AddCommentForm from '../AddCommentForm/AddCommentForm';
import AddPaybackForm from '../AddPaybackForm/AddPaybackForm';
import AppLoader from '../../components/AppLoader/AppLoader';
// import
// AddTheyBoughtMeOperationForm from '../AddTheyBoughtMeOperationForm/AddTheyBoughtMeOperationForm';

export default {
  name: 'AddTransactionForm',
  components: {
    // AddTheyBoughtMeOperationForm,
    AppLoader,
    AddPaybackForm,
    AddCommentForm,
    AddTransferForm,
    AddPurchaseForm,
  },
  methods: {
    spellTransactionType(transaction, user) {
      switch (transaction) {
        case 'even purchase':
          return i18n.t('CP.evenPurchase');
        case 'split purchase':
          return i18n.t('CP.splitPurchase');
        case 'i purchased them':
          return i18n.t(`CP.iBoughtThem_${user.gender || '_M'}`);
        case 'they purchased me':
          return i18n.t('CP.theyBoughtMe');
        case 'i lent them':
          return i18n.t(`CP.iLentThem_${user.gender || '_M'}`);
        case 'they lent me':
          return i18n.t('CP.theyLentMe');
        case 'deposit':
          return i18n.t('CP.deposit');
        case 'payback':
          return i18n.t('CP.payback');
        case 'comment':
          return i18n.t('CP.comment');
        default:
          return '';
      }
    },
  },
  watch: {
    locale() {
      this.$forceUpdate();
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.app.currentLanguage,
      transaction: (state) => state.operations.selectedOperation || '',
      eventTransactionsStatus: (state) => state.events.eventTransactionsStatus || '',
      eventStatus: (state) => state.events.eventStatus || '',
      eventsStatus: (state) => state.events.eventsStatus || '',
      updateTransactionsStatus: (state) => state.events.updateTransactionsStatus,
    }),
    operationType() {
      switch (this.transaction) {
        case 'even purchase':
        case 'split purchase':
        case 'i purchased them':
        case 'they purchased me':
          return 'purchase';
        case 'i lent them':
        case 'they lent me':
          return 'transfer';
        case 'deposit':
          return 'deposit';
        case 'payback':
          return 'payback';
        case 'comment':
          return 'comment';
        default:
          return '';
      }
    },
  },
};
</script>

<style scoped>
.loader-container {
  color: var(--text-main-color);
  min-height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
